import { render, staticRenderFns } from "./IncidentFormReportingView.vue?vue&type=template&id=93fa10a8&scoped=true"
import script from "./IncidentFormReportingView.ts?vue&type=script&lang=ts&external"
export * from "./IncidentFormReportingView.ts?vue&type=script&lang=ts&external"
import style0 from "./IncidentFormReportingView.vue?vue&type=style&index=0&id=93fa10a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa10a8",
  null
  
)

export default component.exports